import * as React from "react";

const MOBILE_BREAKPOINT = 768;
const QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;

function subscribe(onChange: () => void) {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener("change", onChange);
  return () => mql.removeEventListener("change", onChange);
}

/**
 * True below 768px.
 *
 * Read through useSyncExternalStore so a prerendered page hydrates cleanly:
 * while React hydrates it uses the server value (false, the build cannot know
 * the screen) and then re-renders with the real one. Everywhere else the first
 * render already has the real value.
 */
export function useIsMobile() {
  return React.useSyncExternalStore(
    subscribe,
    () => window.innerWidth < MOBILE_BREAKPOINT,
    () => false,
  );
}
